
import React from 'react'
import ListCompanyMaster from '../../../components/companyMaster/listCompanyMaster/ListCompanyMaster'

const ListCompanyMasterPage = () => {
    return (
        <>
            <ListCompanyMaster />
        </>
    )
}

export default ListCompanyMasterPage